import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetDetailsDto } from '@proxy/register-service/assets';
import { LocationService } from '@proxy/register-service/locations';
import { LocationDefinition } from '@register/proxy/register-service/locations';

@Component({
  selector: 'app-jobsite-picker',
  templateUrl: './jobsite-picker.component.html',
  styleUrls: ['./jobsite-picker.component.scss'],
})
export class JobsitePickerComponent {
  @Input() form: FormGroup;
  @Input() asset: AssetDetailsDto;
  @Input() editing: boolean;
  @Input() isRequired: boolean;
  @Input() isLoading: boolean;
  @Output() isLoadingChange = new EventEmitter<boolean>();

  isJobsiteModalOpen = false;
  locationDefinition = LocationDefinition;
  checkedKeys: string[] = [];
  jobsiteNames: string[] = [];

  constructor(private fb: FormBuilder, public readonly locationService: LocationService) {}

  openJobsitePicker() {
    if (!this.editing) {
      this.isJobsiteModalOpen = true;
    }
  }

  onModalClose() {
    this.isJobsiteModalOpen = false;
  }

  selectLocations(keys: string[]) {
    this.checkedKeys = keys;
  }

  formatJobsiteNames() {
    this.jobsiteNames = [];

    this.checkedKeys.forEach(jobsiteId => {
      this.locationService.get(jobsiteId).subscribe(jobsite => {
        this.jobsiteNames.push(jobsite.fullName);
      });
    });

    const jobsiteIdsFormArray = this.form.get('jobsiteIds') as FormArray;

    jobsiteIdsFormArray.clear();
    this.checkedKeys.forEach(id => jobsiteIdsFormArray.push(this.fb.control(id)));

    this.isJobsiteModalOpen = false;
  }

  removeJobsites() {
    this.jobsiteNames = [];
    this.checkedKeys = [];
    const jobsiteIdsFormArray = this.form.get('jobsiteIds') as FormArray;
    jobsiteIdsFormArray.clear();
  }
}
